//import Vue from 'vue';
import Vue from "vue";
import sessionIdDirective from "../directive/sessionId-directive";
import initService from "./init-service";
import commonService from "./common";

let baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let client = `${process.env.VUE_APP_CLIENT}`;

let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': apikey
  }
};

const cdmaDashboardService = {

  async getradchecklist(start, length, total, sort, filter) {
    filter = encodeURI(filter);
    // let url = `${baseurl}?method=cdma_getradchecklist&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    // return Vue.axios.get(url, headers);
    let params = `cdma_getradchecklist&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    return commonService.commonAPI(params,0,15);
  },

  async addradcheck(username, attribute, op, value) {
    username = encodeURI(username);
    op = encodeURI(op);
    value = encodeURI(value);
    let url = `${baseurl}?method=cdma_addradcheck&username=${username}&attribute=${attribute}&op=${op}&value=${value}`;
    return Vue.axios.get(url, headers);
  },

  async updateradcheck(id, username, attribute, op, value) {
    username = encodeURI(username);
    op = encodeURI(op);
    value = encodeURI(value);
    let url = `${baseurl}?method=cdma_updateradcheck&id=${id}&username=${username}&attribute=${attribute}&op=${op}&value=${value}`;
    return Vue.axios.get(url, headers);
  },

  async deleteradcheck(id) {
    let url = `${baseurl}?method=cdma_deleteradcheck&id=${id}`;
    return Vue.axios.get(url, headers);
  },

  async getradreplylist(start, length, total, sort, filter) {
    filter = encodeURI(filter);
    // let url = `${baseurl}?method=cdma_getradreplylist&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    // return Vue.axios.get(url, headers);
    let params = `cdma_getradreplylist&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    return commonService.commonAPI(params,0,15);
  },

  async addradreply(username, attribute, op, value) {
    username = encodeURI(username);
    op = encodeURI(op);
    value = encodeURI(value);
    let url = `${baseurl}?method=cdma_addradreply&username=${username}&attribute=${attribute}&op=${op}&value=${value}`;
    return Vue.axios.get(url, headers);
  },

  async updateradreply(id, username, attribute, op, value) {
    username = encodeURI(username);
    op = encodeURI(op);
    value = encodeURI(value);
    let url = `${baseurl}?method=cdma_updateradreply&id=${id}&username=${username}&attribute=${attribute}&op=${op}&value=${value}`;
    return Vue.axios.get(url, headers);
  },

  async deleteradreply(id) {
    let url = `${baseurl}?method=cdma_deleteradreply&id=${id}`;
    return Vue.axios.get(url, headers);
  },

  async getradusergroupList(start, length, total, sort, filter) {
    filter = encodeURI(filter);
    // let url = `${baseurl}?method=cdma_getradusergroupList&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    // return Vue.axios.get(url, headers);
    let params = `cdma_getradusergroupList&start=${start}&length=${length}&total=${total}&sort=${sort}&filter=${filter}`;
    return commonService.commonAPI(params,0,15);
  },

  async addradusergroup(username, groupname, priority) {
    username = encodeURI(username);
    groupname = encodeURI(groupname);
    let url = `${baseurl}?method=cdma_addradusergroup&username=${username}&groupname=${groupname}&priority=${priority}`;
    return Vue.axios.get(url, headers);
  },

  async updateradusergroup(username, groupname, priority) {
    username = encodeURI(username);
    groupname = encodeURI(groupname);
    let url = `${baseurl}?method=cdma_updateradusergroup&username=${username}&groupname=${groupname}&priority=${priority}`;
    return Vue.axios.get(url, headers);
  },

  async deleteradusergroup(username) {
    username = encodeURI(username);
    let url = `${baseurl}?method=cdma_deleteradusergroup&username=${username}`;
    return Vue.axios.get(url, headers);
  },

  async getmonthlyuserreport(startDate, endDate) {
    let url = `${baseurl}?method=cdma_getmonthlyuserreport&startDate=${startDate}&endDate=${endDate}`;
    return Vue.axios.get(url, headers);
  }

};

export default cdmaDashboardService;
